export default {
  allDescription: {
    id: 'review_display_all_reviews_meta_description_new',
    defaultMessage:
      'Wondering if Backmarket services are reliable? Are prices a scam? Overall rating is {rate} out of {count} reviews. Read all of our customer reviews.',
  },
  allTitle: {
    id: 'review_display_all_reviews_meta_title',
    defaultMessage:
      'Is Back Market reputable? Read reviews for all our refurbished electronics | Back Market',
  },
  landingDescription: {
    id: 'review_display_landing_meta_description_new',
    defaultMessage:
      'Wondering if {productName} sold on Back Market are reliable? Is there a scam? Our overall rating is {rate} out of {count} reviews. Read all of our customer reviews.',
  },
  landingTitle: {
    id: 'review_display_landing_meta_title_new',
    defaultMessage:
      'Customer reviews for all refurbished {productName} | Back Market',
  },
  merchantDescription: {
    id: 'review_display_merchant_meta_description_new',
    defaultMessage:
      'Wondering if a seller on Backmarket - {merchantName} - is reliable? Are their refurbished electronics of good quality? Our overall rating is {rate} out of {count} reviews. Read all of our customer reviews.',
  },
  merchantTitle: {
    id: 'review_display_merchant_meta_title_new',
    defaultMessage:
      'Customer reviews for a specific seller - {merchantName} | Back Market',
  },
  productDescription: {
    id: 'review_display_product_meta_description_new',
    defaultMessage:
      'Wondering if the product called {productName} - is reliable? Our overall rating is {rate} out of {count} reviews. Read all of our customer reviews.',
  },
  productTitle: {
    id: 'review_display_product_meta_title_new',
    defaultMessage:
      'Customer reviews for a specific product - {productName} | Back Market',
  },
  productNamePlaceholder: {
    id: 'review_display_product_name_placeholder',
    defaultMessage: 'Product page',
  },
}
